export const routes = {
  home: "/",
  about: "/about",
  term: "/term-policy",
  privacy: "/privacy-policy",
  auth: {
    login: "/auth/login",
    signup: "/auth/signup",
    register: "/auth/register",
    forgot: "/auth/forgot",
  },
  job: {
    index: "/job",
    detail: "/job/:slug",
    detailPath: "/job/",
    category: "/job/category/:slug",
    categoryPath: "/job/category/",
  },
  company: {
    index: "/company",
    list: "/companies",
    detail: "/companies/:slug",
    detailPath: "/companies/",
  },
  interviewer: {
    index: "/interviewer",
  },
  candidate: {
    profile: "/candidate/profile",
    applicants: "/candidate/applicants",
    message: "/candidate/message",
    refer: "/candidate/refer",
    setting: "/candidate/setting",
    notification: "/candidate/notification",
    interview: {
      schedules: "/candidate/interview/schedules",
    },
    work: {
      history: "/candidate/work/history",
    },
  },
};

export const publicRoutes = [
  routes.home,
  routes.about,
  routes.term,
  routes.privacy,
  routes.auth.login,
  routes.auth.signup,
  routes.auth.register,
  routes.auth.forgot,
  routes.job.index,
  routes.job.detailPath + "*",
  routes.job.categoryPath + "*",
  routes.company.index,
  routes.company.list,
  routes.company.detailPath + "*",
];

export const privateRoutes = [
  routes.candidate.profile,
  routes.candidate.applicants,
  routes.candidate.message,
  routes.candidate.refer,
  routes.candidate.setting,
  routes.candidate.notification,
  routes.candidate.interview.schedules,
  routes.candidate.work.history,
];
